import routes from './routes'
import { Fetch } from '../fetch'

class LoadDetailService {
  async bidOrder (payload) {
    return Fetch('post', routes.bidOrder, payload)
  }

  async bookOrder (payload) {
    return Fetch('post', routes.bookOrder, payload)
  }

  async bidOffer (payload) {
    return Fetch('post', routes.bidOffer, payload)
  }

  async bookOffer (payload) {
    return Fetch('post', routes.bookOffer, payload)
  }

  async getMapImage (payload) {
    return Fetch('post', routes.getMapImage, payload)
  }

  async getTractorDetails (payload) {
    return Fetch('get', routes.getTractorDetails(payload))
  }
}

export default new LoadDetailService()
